import Dialog from '@mui/material/Dialog';
import React, { useEffect, useState } from 'react';
import { DialogActions, DialogContent } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import { useDispatch } from 'react-redux';
import { getDocumentsForCollection } from '../../../../../../../../../../lib/api/collections';
import TableWithPagination from '../../../../../../../../../../lib/designSystem/TableWithPagination';
import CenteredCircularProgress from '../../../../../../../../../../lib/designSystem/CircularProgress';
import CustomButton from '../../../../../../../../../../lib/designSystem/Button';

const DocumentIndicatorDocumentDetails = (props: any) => {
  const { documentsIds, open, setOpen, managementFilter } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [documents, setDocuments] = useState([]);
  const PAGE_SIZE = 10;
  const [pagination, setPagination] = useState({
    page: 0,
    pageSize: PAGE_SIZE,
    total: 0,
    totalPages: 0,
  });

  const generateQuery = ({
    page,
    pageSize,
    exportComplete,
  }: {
    page: number;
    pageSize: number;
    exportComplete: boolean;
  }) => {
    let query = '';
    if (documentsIds) query += `documentsIds=${documentsIds}&`;
    if (page) query += `page=${page}&pageSize=${pageSize}&`;
    if (exportComplete) query += `exportComplete=true&`;
    return query;
  };

  const fetchInvoices = async ({
    page,
    pageSize,
    exportComplete = false,
  }: {
    page: number;
    pageSize: number;
    exportComplete?: boolean;
  }) => {
    try {
      const query = generateQuery({ page, pageSize, exportComplete });
      const response = await getDocumentsForCollection(dispatch, query);
      if (!exportComplete) {
        setDocuments(response.data);
        setPagination(response.pagination);
      }
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const setUp = async () => {
    setLoading(true);
    await fetchInvoices({ page: 0, pageSize: PAGE_SIZE });
    setLoading(false);
  };

  useEffect(() => {
    setUp();
  }, []);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
      <DialogTitle>
        Documentos {managementFilter === 'management' ? 'con' : 'sin'} gestión
      </DialogTitle>
      {loading && (
        <div style={{ height: 300 }}>
          <CenteredCircularProgress type="dialog" />
        </div>
      )}
      {!loading && (
        <DialogContent>
          <TableWithPagination
            dataHeaders={[
              {
                key: 'autoCollectionStatus',
                label: 'En flujo',
                type: 'auto-collection-status',
              },

              {
                key: 'invoiceType',
                label: 'Tipo',
                type: 'invoice-type-no-icon',
              },
              {
                key: 'businessName',
                label: 'Emisor',
                // handleAction: handleShowBusinessDetails,
                // icon: <Info fontSize="small" />,
              },
              {
                key: 'businessIdentifier',
                label: 'Rut',
              },
              {
                key: 'stakeholderName',
                label: 'Receptor',
                // handleAction: handleShowStakeholderDetails,
                // icon: <Info fontSize="small" />,
              },

              {
                key: 'stakeholderIdentifier',
                label: 'Rut',
              },
              { key: 'folio', label: 'Folio' },
              { key: 'amount', label: 'Monto', type: 'money' },
              {
                key: 'amountConciliated',
                label: 'Conciliado',
                type: 'money',
              },
              {
                key: 'documentRemainingAmountNet',
                label: 'Adeudado',
                type: 'invoice-remaining-amount',
              },
              { key: 'paymentDate', label: 'Vencimiento', type: 'date' },
              {
                key: 'arrearTrench',
                label: 'Tramo de mora',
                type: 'arrear-trench',
              },
              {
                key: 'arrearDays',
                label: 'Días de mora',
              },
              {
                key: 'possiblePaymentDate',
                label: 'Posible pago',
                type: 'date',
              },
              { key: 'extensionDate', label: 'Extensión', type: 'date' },
              { key: 'fundName', label: 'Fondo' },
              { key: 'cancelDate', label: 'Rechazado', type: 'date' },
              { key: 'confirmDate', label: 'Confirmado', type: 'date' },
              {
                key: 'lastCollectionManagementState',
                label: 'Estado gestión',
              },
              {
                key: 'lastCollectionManagementSubState',
                label: 'Subestado gestión',
              },

              { key: 'operationDate', label: 'Fecha Solicitud', type: 'date' },
              { key: 'operationId', label: 'Solicitud', type: 'numeric-id' },
              { key: 'collectorName', label: 'Ejecutivo' },
              {
                key: 'lastConciliationDate',
                label: 'Última conciliación',
                type: 'date',
              },
              {
                key: 'lastConciliationName',
                label: 'Tipo conciliación',
              },
              {
                key: 'stakeholderSalesSegment',
                label: 'Segmento comercial',
                type: 'sales-segment',
              },
              {
                key: 'stakeholderEconomicSegment',
                label: 'Segmento económico',
              },
              {
                key: 'stakeholderEconomicSubSegment',
                label: 'Subsegmento económico',
              },
              {
                key: 'stakeholderEconomicActivity',
                label: 'Actividad económica',
              },
              { key: 'stakeholderRegion', label: 'Región' },
              { key: 'stakeholderCommune', label: 'Comuna' },
              { key: 'stakeholderCollaborators', label: 'Colaboradores' },
            ]}
            data={documents}
            pagination={pagination}
            setPagination={setPagination}
            setLoading={setLoading}
            exportToFile="xlsx"
            exportComplete
            setData={setDocuments}
            searchData={fetchInvoices}
            loading={loading}
          />
        </DialogContent>
      )}
      <DialogActions>
        <CustomButton
          onClick={() => setOpen(false)}
          variant="contained"
          color="secondary"
        >
          Cerrar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentIndicatorDocumentDetails;
